import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../../../shared/notifiers/base-notifier';
import { Ref } from '../../../../shared/providers/ref';
import { IdentifyState } from './identify-state';
import { PopupInteractionProvider } from './popup-interaction/popup-interaction-provider';

@Injectable()
export class IdentifyNotifier extends BaseNotifier<IdentifyState> {
  private static readonly INITIAL: IdentifyState = {
    active: false,
  };

  constructor(ref: Ref) {
    super(ref, IdentifyNotifier.INITIAL);
  }

  toggle(): void {
    this.setEnabled(!this.snapshot().active);
  }

  setEnabled(active: boolean): void {
    this.setState({ active });
    const popupInteraction = this.ref.watch(PopupInteractionProvider);
    popupInteraction.notifier.setEnabled(active);
  }
}
